/* eslint-disable max-len */
/**
 * Internal dependencies
 */
import { PREFIX_EVENTS_PRO_STORE } from '@moderntribe/events-pro/data/prefix';

export const TOGGLE_REPEAT_EVENTS_BLOCK_VISIBILITY = `${ PREFIX_EVENTS_PRO_STORE }/TOGGLE_REPEAT_EVENTS_BLOCK_VISIBILITY`;

export const TOGGLE_RULE_PANEL_VISIBILITY = `${ PREFIX_EVENTS_PRO_STORE }/TOGGLE_RULE_PANEL_VISIBILITY`;
export const HIDE_RULE_PANEL = `${ PREFIX_EVENTS_PRO_STORE }/HIDE_RULE_PANEL`;

export const TOGGLE_RULE_PANEL_EXPAND = `${ PREFIX_EVENTS_PRO_STORE }/TOGGLE_RULE_PANEL_EXPAND`;
export const EXPAND_RULE_PANEL = `${ PREFIX_EVENTS_PRO_STORE }/EXPAND_RULE_PANEL`;

export const TOGGLE_EXCEPTION_PANEL_VISIBILITY = `${ PREFIX_EVENTS_PRO_STORE }/TOGGLE_EXCEPTION_PANEL_VISIBILITY`;
export const HIDE_EXCEPTION_PANEL = `${ PREFIX_EVENTS_PRO_STORE }/HIDE_EXCEPTION_PANEL`;

export const TOGGLE_EXCEPTION_PANEL_EXPAND = `${ PREFIX_EVENTS_PRO_STORE }/TOGGLE_EXCEPTION_PANEL_EXPAND`;
export const EXPAND_EXCEPTION_PANEL = `${ PREFIX_EVENTS_PRO_STORE }/EXPAND_EXCEPTION_PANEL`;
